import React, { Component } from 'react';
import RequestSupportDialog from '../../misc/RequestSupportDialog';
import RequestAccountDialog from '../../misc/RequestAccountDialog';
import urlHandler from '../../../utils/urlHandler';

class DocOverview extends Component {
    constructor(props){
        super(props);

        // this.showAcctDialog = this.showAcctDialog.bind(this);
        // this.showSupportDialog = this.showSupportDialog.bind(this);
    }

    // showAcctDialog() {
    //     this.refs.acctdlg.open();
    // }

    // showSupportDialog() {
    //     this.refs.supportdlg.open();
    // }

    render() {

        return (
            <div id="top">
                {/* <RequestAccountDialog ref="acctdlg" hidden={true}/>
                <RequestSupportDialog ref="supportdlg" hidden={true}/> */}
                <h1 className="heading-1">Getting Started</h1>
                <p className="description">
                    {/* For free access, join our demonstration program by <button className="link-button" onClick={this.showAcctDialog}>requesting an account</button>.
                    You will receive a user name and password from Finch Computing within 24 hours.

                    At any time and with any questions, you may also <button className="link-button" onClick={this.showSupportDialog}>contact support</button>.
                    We look forward to hearing from you and appreciate your feedback. */}
                </p>

                <h3 className="heading-2" id="over">Overview</h3>
                <div className="bucket">
                    <div className="description">
                        Finch for Text® is a cloud-hosted service that provides real-time text analytics. We offer a rich suite of services designed to address a variety of challenging text analysis use cases. 

                        <h3 className="heading-3">Services Offered</h3>
                        <p>
                            Our growing range of text analytics services includes:
                        </p>

                        <div className="bullet-list">
                            <ul className="toc-level list-wrapper">
                                <li className="list-item">Entity extraction of over 20 entity types</li>
                                <li className="list-item">Entity disambiguation, resolving entity mentions to our knowledgebase of tens of millions of entities</li>
                                <li className="list-item">Entity enrichment, appending entity metadata to each entity</li>
                                <li className="list-item">Document concept tagging, classifying and tagging documents to standard or custom concept/topic taxonomies</li>
                                <li className="list-item">Sentiment scoring for documents, sentences and entities</li>
                                <li className="list-item">Key phrase extraction</li>
                                <li className="list-item">Topic vector inference for document similarity comparisons</li>
                            </ul>
                        </div>
                        For a typical entity extraction and disambiguation scenario, the Finch for Text API accepts your text input 
                        request and produces a JSON formatted text analysis report.<br/><br/>  

                        <h3 className="heading-3">Entity Identification</h3>

                        Finch for Text identifies various entities, including people, places, organizations, and things. We also offer custom extractions for specific content areas, such as cybersecurity and finance, supporting entity types like cyber, monetary, measurements, dates, and more! By examining the relevant context surrounding these entities, Finch for Text can distinguish between entities with similar names. 

                        <h3 className="heading-3">Additional Features</h3>
                        <p>
                            Additional features include:
                        </p>
                        <div className="bullet-list">
                            <ul className="toc-level list-wrapper">
                                <li className="list-item">Document taxonomy tagging</li>
                                <li className="list-item">Sentiment scoring</li>
                                <li className="list-item">Key phrase extraction</li>
                                <li className="list-item">Topic mining for similarity scoring</li>
                            </ul>
                        </div>
                        <p>
                            We also provide options for custom models and scoring threshold parameters to optimize the analysis.
                        </p>
                    </div>
                </div>

                <h3 className="heading-2" id="auth">Authentication</h3>
                <div className="bucket">
                    <div className="description">
                        All REST endpoints are access-restricted and require a valid API key.
                        Each API call must include a valid Authorization header that contains the API key in the following format:
                        <br/>
                    </div>

                    <table className="table-wrapper enrich">
                        <thead className="table-header enrich">
                        <tr>
                            <th>Header</th>
                            <th>Value</th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td>
                                <code>Authorization</code>
                            </td>
                            <td>
                                <code>Bearer &lt;your api key&gt;</code>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <p>
                        For example:
                    </p>
          
                    <div className="example-content host">
                        <pre>
                            POST {urlHandler.API_ENDPOINT_V2_ENRICH} HTTP/1.1<br/>
                            Host: text-api.finchcomputing.com<br/>
                            Authorization: Bearer 286b8472073b5e09b59ae46238c666576a7eeb582aea4b0fa1d666575c4ae18z<br/>
                        </pre>
                    </div>
                    <div className="description">
                        We also support the <code>X-Finch</code> Authorization header. Below is a sample request
                        that contains the API key in the following format:
                    </div>

                    <table className="table-wrapper enrich">
                        <thead className="table-header enrich">
                        <tr>
                            <th>Header</th>
                            <th>Value</th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td>
                                <code>X-Finch</code>
                            </td>
                            <td>
                                <code>Bearer &lt;your-api-key&gt;</code>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <p>For example:</p>
                    <div className="example-content host">
                        <pre>
                            POST {urlHandler.API_ENDPOINT_V2_ENRICH} HTTP/1.1<br/>
                            Host: text-api.finchcomputing.com<br/>
                            X-Finch: Bearer 286b8472073b5e09b59ae46238c666576a7eeb582aea4b0fa1d666575c4ae18z<br/>
                        </pre>
                    </div>
                    <br/>
                    <div className="description">
                        {/* <i>(To obtain an api key please <button className="link-button" onClick={this.showAcctDialog}>request an account</button>.)</i> */}


                        <h3 className="heading-2" id="error">Response Codes</h3>
                        <div className="description">
                            The Finch for Text service utilizes standard HTTP status codes to indicate whether an operation has completed successfully. A plain text error message is also available in the response's content body. The following response codes are supported.
                        </div>

                        <table className="table-wrapper enrich">
                            <thead className="table-header enrich">
                            <tr>
                                <th>Code </th>
                                <th>Status Text </th>
                                <th>Description </th>
                            </tr>
                            </thead>
                            <tbody className="table-body">
                            <tr>
                                <td className="attribute">200</td>
                                <td className="status-text">OK</td>
                                <td className="notes">The request has succeeded.</td>
                            </tr>
                            <tr>
                                <td className="attribute">201</td>
                                <td className="status-text">Created</td>
                                <td className="notes">The entity was created successfully.</td>
                            </tr>
                            <tr>
                                <td className="attribute">204</td>
                                <td className="status-text">No Content</td>
                                <td className="notes">The request succeeded but the server is not returning any content.</td>
                            </tr>
                            <tr>
                                <td className="attribute">250</td>
                                <td className="status-text">Partial Success</td>
                                <td className="notes">The response contains partial results. This can occur if one or more entities is 
                                    not able to be disambiguated or fully enriched. The data in the response is still accurate, 
                                    but the disambiguation results might be incomplete. For example, all entity extractions will be 
                                    present but one or more entities may not have been disambiguated.
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">400</td>
                                <td className="status-text">Bad Request</td>
                                <td className="notes">The request could not be understood or was malformed. Confirm that the request is 
                                    constructed correctly and the service URL is correct.
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">401</td>
                                <td className="status-text">Unauthorized</td>
                                <td className="notes">Authentication failed due to an invalid credential.</td>
                            </tr>
                            <tr>
                                <td className="attribute">403</td>
                                <td className="status-text">Forbidden</td>
                                <td className="notes">Authorization failed. User does not have permission 
                                    to access the requested resource. Authorized resources include the REST 
                                    endpoint, entity types, specific sentiment and topic models and 
                                    other parameters.</td>
                            </tr>
                            <tr>
                                <td className="attribute">404</td>
                                <td className="status-text">Not Found</td>
                                <td className="notes">The entity was not found.</td>
                            </tr>
                            <tr>
                                <td className="attribute">409</td>
                                <td className="status-text">Conflict</td>
                                <td className="notes">Indicates a concurrency issue. The version of the entity 
                                    sent in the request is older than the version found in the KB.
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">413</td>
                                <td className="status-text">Request Entity Too Large</td>
                                <td className="notes">The server is refusing to process a request because the request size is larger 
                                    than the service is configured to process. 
                                    {/* Contact <button className="link-button" onClick={this.showSupportDialog}>customer support</button> if you need to process 
                                    larger documents. */}
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">423</td>
                                <td className="status-text">Locked</td>
                                <td className="notes">Indicates that the entity is in the process of being updated when 
                                    the delete or update request was received.</td>
                            </tr>
                            <tr>
                                <td className="attribute">429</td>
                                <td className="status-text">Too many Requests</td>
                                <td className="notes">The user has sent too many requests in a given amount of time. See <a href="#rate-limits">Rate Limits</a>.
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">500</td>
                                <td className="status-text">Internal Server Error</td>
                                <td className="notes">The server encountered an unexpected condition which prevented it from 
                                    fulfilling the request. We work hard to ensure you never see this code. However, if you 
                                    do get this status code, oftentimes a retry of the request is successful. 
                                    {/* If a given request 
                                    consistently returns this status code, please contact <button className="link-button" onClick={this.showSupportDialog}>customer support</button> or submit feedback 
                                    using the <a href="/demo">demo site</a>. */}
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">503</td>
                                <td className="status-text">Service Temporarily Unavailable</td>
                                <td className="notes">The server is not ready to handle the request. This indicates that the system 
                                    is too busy and unable to process the request at this time. The HTTP response header “Retry-After” 
                                    contains an estimate (in seconds) indicating how long the caller should wait before retrying the request.
                                </td>
                            </tr>
                            <tr>
                                <td className="attribute">504</td>
                                <td className="status-text">Gateway Timeout</td>
                                <td className="notes">The server, while acting as a gateway or proxy, did not receive a timely 
                                    response from an upstream server it needed to access in order to complete the request.
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>                
                <h3 className="heading-2" id="rate-limits">Rate Limiting</h3>
                <div className="bucket">
                    <div className="description">
                        The REST endpoints may have rate limiting enabled, which controls the rate of traffic received by our servers. Rate limits are specific to each account and are established based on the level of service included in your Finch for Text® license. When rate limits are enforced, the following response headers will be present:
                    </div>
                    <table className="table-wrapper enrich">
                        <thead className="table-header enrich">
                        <tr>
                            <th>Response Header </th>
                            <th>Description </th>
                            <th>Type </th>
                        </tr>
                        </thead>
                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">X-RateLimit-Limit</td>
                            <td className="status-text">Request limit per minute. This is the maximum number of requests your account 
                                can make each minute.
                            </td>
                            <td className="notes">Positive Integer</td>
                        </tr>
                        <tr>
                            <td className="attribute">X-RateLimit-Remaining</td>
                            <td className="status-text">The number of requests remaining for the current one-minute time window.</td>
                            <td className="notes">Positive Integer</td>
                        </tr>
                        <tr>
                            <td className="attribute">X-RateLimit-Reset</td>
                            <td className="status-text">The remaining time (in seconds) before the rate limit resets and requests 
                                will be accepted again.
                            </td>
                            <td className="notes">Positive Integer</td>
                        </tr>
                        </tbody>
                    </table>
                    <h4 className="subheader">Example</h4>
                    <div className="description">
                        Below is an example of the headers that can be returned. In this example:
                        <div className="bullet-list">
                            <ul className="toc-level list-wrapper">
                                <li className="list-item">The user account can make 90 requests per minute.</li>
                                <li className="list-item">The user can make 87 more requests in the current one-minute window.</li>
                                <li className="list-item">The current rate limiting window will reset in 34 seconds.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="example-content">
                        <pre>
                            HTTP/1.1 200 OK<br/>
                            Access-Control-Allow-Headers: Authorization, accept, origin, content-type, X-Requested-With<br/>
                            Access-Control-Allow-Methods: PUT, POST, GET, PATCH, DELETE, OPTIONS, LINK, UNLINK<br/>
                            Access-Control-Allow-Origin: *<br/>
                            Content-Length: 9262<br/>
                            Content-Type: application/json<br/>
                            X-Http-Status-Code: 200<br/>
                            X-Ratelimit-Limit: 90<br/>
                            X-Ratelimit-Remaining: 87<br/>
                            X-Ratelimit-Reset: 34<br/>
                            Date: Thu, 26 Oct 2017 20:33:49 GMT<br/>
                        </pre>
                    </div>
                </div>
            </div>
        );
    }
}

export default DocOverview;